import { v as d } from "./validate-feature-flags-config-Dey5OQSF.mjs";
import "@smart/types";
import "./index-xuotMAFm.mjs";
import { S as h } from "./smart-hash-CJtw9ia-.mjs";
function p(e, r, a) {
  var t;
  if (!a)
    return !1;
  const s = a[e];
  return s ? !!(s.enabledGlobally || ((t = s.markets) == null ? void 0 : t[r.toUpperCase()])) : !1;
}
const U = (e) => {
  globalThis.smart_featureFlags = e;
}, F = () => globalThis.smart_featureFlags, k = (e, r) => {
  const a = F();
  return a || console.error("featureFlags are not set in globalThis."), p(e, r || "", a);
}, w = (e) => {
  const r = F();
  if (!r)
    throw Error("featureFlags are not set in globalThis.");
  return d(r, e);
};
var c = /* @__PURE__ */ ((e) => (e.Key = "x-ff-override-key", e.Flags = "x-ff-override-flags", e))(c || {});
const G = async (e, r) => {
  try {
    let a = {};
    r && [c.Key, c.Flags].forEach((n) => {
      const l = r.headers[n];
      l ? a[n] = l : a = {};
    });
    const { apiUrl: s } = m(e), o = await fetch(s, {
      headers: a
    });
    if (!o.ok)
      throw new Error(`Failed to fetch feature flags: ${o.statusText}`);
    const t = await o.json(), f = await h.hash(t);
    return {
      ...t,
      checksum: f
    };
  } catch (a) {
    return console.error("Error fetching feature flags:", a), null;
  }
}, m = (e) => {
  const { marketId: r, envName: a, preview: s, projectId: o, flagId: t, userId: f, baseUrl: u } = e, g = encodeURIComponent(
    JSON.stringify({
      marketId: r,
      envName: a,
      preview: s,
      userId: f
    })
  ), n = t ? `/${t}` : "", l = `v1/flags/${o}${n}?filter=${g}`;
  return {
    apiUrl: ((i) => i ? i.endsWith("/") ? i + l : `${i}/${l}` : `https://api.${a}.feature-flags.srv.smart.com/${l}`)(u)
  };
};
export {
  c as O,
  k as a,
  m as b,
  G as f,
  F as g,
  p as i,
  U as s,
  w as v
};
//# sourceMappingURL=fetch-feature-flags-wEM-95W-.mjs.map
